import type {BaseComponentPart} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';

export enum EntityCardSkeletonMode {
  LOADING = 'loading',
  GENERATING = 'generating',
}

export interface EntityCardSkeletonProps {
  mode: EntityCardSkeletonMode;
}

export type EntityCardSkeletonComponentPart = BaseComponentPart<StreamComponentType.ENTITY_CARD_SKELETON, EntityCardSkeletonProps>;
